// ===========================================================
// ||                RECIPE FILTER LOGIC                    ||
// ===========================================================

const recipesEl = document.getElementById('recipeScript'),
      recipesJSON = JSON.parse(recipesEl.innerText),
      recipeContainer = document.querySelector('.recipe-container'),
      storedFlavors = [], 
      storedBrands = [],
      storedOccasions = [];

  let flavorExists = false,
      brandExists = false,
      occasionExists = false;

function arraysHaveValues() {
  if(storedFlavors.length){
    flavorExists = true;
  }else {
    flavorExists = false;
  }
  if(storedBrands.length){
    brandExists = true;
  }else {
    brandExists = false;
  }
  if(storedOccasions.length){
    occasionExists = true;
  }else {
    occasionExists = false;
  }
}

function renderRecipes(){
  recipeContainer.innerHTML = '';

  for(let key in recipesJSON.recipesData) {
    let flavor = recipesJSON.recipesData[key].recipeFlavor.split(','),
        brand = recipesJSON.recipesData[key].recipeBrand.split(','),
        occasion = recipesJSON.recipesData[key].recipeOccasion.split(','),
        image = recipesJSON.recipesData[key].recipeImage,
        title = recipesJSON.recipesData[key].recipeTitle;

    if(flavorExists && !brandExists && !occasionExists){
      if(!storedFlavors.some(value => flavor.includes(value))){
        continue;
      }
    }else if(!flavorExists && brandExists && !occasionExists) {
      if(!storedBrands.some(value =>brand.includes(value))){
        continue;
      }
    }else if(!flavorExists && !brandExists && occasionExists) {
      if(!storedOccasions.some(value =>occasion.includes(value))){
        continue;
      }
    }else if(flavorExists && brandExists && !occasionExists) {
      if(!flavor.every(value =>storedFlavors.includes(value)) || !brand.every(value =>storedBrands.includes(value))){
        continue;
      }
    }else if(flavorExists && !brandExists && occasionExists) {
      if(!flavor.every(value =>storedFlavors.includes(value)) || !occasion.every(value =>storedOccasions.includes(value))){
        continue;
      }
    }else if(!flavorExists && brandExists && occasionExists) {
      if(!brand.some(value =>storedBrands.includes(value)) || !occasion.some(value =>storedOccasions.includes(value))){
        continue;
      }
    }else if(flavorExists && brandExists && occasionExists) {
      if(!flavor.some(value =>storedFlavors.includes(value)) || !brand.some(value =>storedBrands.includes(value)) || !occasion.some(value =>storedOccasions.includes(value))){
        continue;
      }
    }

    let recipeBlock = `
    <a class="grid__item" 
    data-flavor="`+ flavor +`"
    data-brand="`+ brand +`"
    data-occasion="`+ occasion +`"
    href="{{ recipe.system.url }}">
      <div class="recipe ">
        <div class="recipe-image">
          <img src="`+ image +`">
        </div>
        <div class="recipe-info">
          <h3 class="truncate-text">`+ title +`</h3>
        </div>
      </div>
    </a>
    `
    recipeContainer.insertAdjacentHTML('beforeend', recipeBlock);
  }
}

function handleRecipeFilterCheck(type, value) {
  switch (type) {
    case 'flavor':
      if(!storedFlavors.includes(value)){
        storedFlavors.push(value);
      }
      break;
    case 'brand':
      if(!storedBrands.includes(value)){
        storedBrands.push(value);
      }
      break;
    case 'occasion':
      if(!storedOccasions.includes(value)){
        storedOccasions.push(value);
      }
      break;
  }

  if(document.querySelector('.recipes .pagination')){
    document.querySelector('.recipes .pagination').remove();
  }

  arraysHaveValues();
  renderRecipes();
}

function handleRecipeFilterUncheck(type, value) {
  switch (type) {
    case 'flavor':
      if(storedFlavors.includes(value)){
        let index = storedFlavors.indexOf(value);
        storedFlavors.splice(index);
      }
      break;
    case 'brand':
      if(storedBrands.includes(value)){
        let index = storedBrands.indexOf(value);
        storedBrands.splice(index);
      }
      break;
    case 'occasion':
      if(storedOccasions.includes(value)){
        let index = storedOccasions.indexOf(value);
        storedOccasions.splice(index);
      break;
    }
  }

  arraysHaveValues();
  renderRecipes();
}

function handleRecipeFilterCatClick(type){
  const filterValues = document.querySelector('.recipe-filter-values__container[data-cat="'+ type +'"]');

  if(filterValues.classList.contains('active')){
    filterValues.classList.remove('active');
  }else {
    if(document.querySelector('.recipe-filter-values__container.active')){
      document.querySelector('.recipe-filter-values__container.active').classList.remove('active');
    }  
    filterValues.classList.add('active');
  }
}

window.onload = function() {
  document.querySelectorAll('.recipe-filter-values div input').forEach(function(e){
    e.addEventListener('change', function(){
      if(this.checked){
        handleRecipeFilterCheck(this.getAttribute('data-type'), this.getAttribute("value"))
      }else{
        handleRecipeFilterUncheck(this.getAttribute('data-type'), this.getAttribute("value"))
      }
    });
  });

  document.querySelectorAll('.recipe-filter-cat span').forEach(function(e){
    e.addEventListener('click', function(){
      if(this.classList.contains('active')){
        this.classList.remove('active');
      }else {
        if(document.querySelector('.recipe-filter-cat span:not(.icon-chev).active')){
          document.querySelector('.recipe-filter-cat span:not(.icon-chev).active').classList.remove('active');
        }
        this.classList.add('active');
      }
      handleRecipeFilterCatClick(this.getAttribute('data-cat'));
    });
  })
}